import { Outlet, useLocation, useNavigate } from "react-router-dom";
import "./App.css";
import NavbarComponent from "./app_components/Navbar/NavbarComponent";
import { Toaster } from "./components/ui/sonner";
import Footer from "./app_components/Footer/Footer";
import { UNPROTECTED_ROUTES, PROTECTED_ROUTES } from "./routes/routes";
import { useEffect, useLayoutEffect, useState } from "react";
import WhatsappFLoating from "./app_components/FloatingIcons/WhatsappFLoating";
import ScrollToTopFloating from "./app_components/FloatingIcons/ScrollToTopFloating";
import { useDispatch, useSelector } from "react-redux";
import CollapsedSIdebar from "./app_components/Sidebar/CollapsedSIdebar";
import UnCollapsedSidebar from "./app_components/Sidebar/UnCollapsedSidebar/UnCollapsedSidebar";
import { Home, BookOpen, Library, FileText, GraduationCap } from "lucide-react";
import userLogout from "./utils/userLogout";
import installAuthResponseHandler from "./utils/installAuthResponseHandler";

function App() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showScrollToTop, setShowScrollToTop] = useState(false);
  const isSideBarOpen = useSelector((store) => store.sidebar.isSideBarOpen);

  useLayoutEffect(() => installAuthResponseHandler(() => {
    userLogout(
      null,
      dispatch,
      true,
      "Your session has expired. Please log in again.",
      false
    );
  }), [dispatch]);

  useEffect(() => {
    // Disable right-click on the whole document
    const handleContextMenu = (event) => {
      event.preventDefault();
    };

    // Disable specific key combinations
    const handleKeyDown = (event) => {
      if (
        event.keyCode === 123 || // F12
        (event.ctrlKey && event.shiftKey && event.keyCode === 73) || // Ctrl+Shift+I (Windows)
        (event.metaKey && event.altKey && event.keyCode === 73) || // Cmd+Option+I (Mac)
        (event.ctrlKey && event.shiftKey && event.keyCode === 74) || // Ctrl+Shift+J (Windows)
        (event.metaKey && event.altKey && event.keyCode === 74) || // Cmd+Option+J (Mac)
        (event.ctrlKey && event.keyCode === 85) || // Ctrl+U (Windows)
        (event.metaKey && event.keyCode === 85) // Cmd+U (Mac)
      ) {
        event.preventDefault();
      }
    };

    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("keydown", handleKeyDown);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  useEffect(() => {
    if (window.history && "scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
    if (
      !location.pathname.includes(
        UNPROTECTED_ROUTES?.lecture
      ) &&
      !location.pathname.includes(UNPROTECTED_ROUTES?.notes)
    ) {
      window.scrollTo(0, 0);
    }
  }, [location]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) {
        setShowScrollToTop(true);
      } else {
        setShowScrollToTop(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const hideFooterPaths = [
    UNPROTECTED_ROUTES?.login,
    UNPROTECTED_ROUTES?.studentDetails,
    "/library",
    "/library/videos",
    "/library/notes",
    "/library/tests",
    "/courses/all",
    "/courses/my",
    "/test-series/all",
    "/test-series/my",
    "/books/all",
    "/books/my",
    "/course_details/31/description",
    "/course_details/31/liveclass",
    "/course_details/31/classroom/lecture",
    "/course_details/31/livetests",
    "/course_details/31/dpp",
    "/course_details/31/announcement",
    "/course_details/1/description",
    "/course_details/1/liveclass",
    "/course_details/1/classroom/lecture",
    "/course_details/1/livetests",
    "/course_details/1/dpp",
    "/course_details/1/announcement",
    "/support",
    "/feedback",
    "/profile",
    "/buy"
    // "/classroom/1607/8"
  ];
  const isHideFooterPath =
    hideFooterPaths.includes(location.pathname) ||
    location.pathname.startsWith("/classroom/") ||
    location.pathname.startsWith("/live/") ||
     location.pathname.startsWith("/library/videos/play/") ||
    (
      location.pathname.startsWith("/test_details/") &&
      (
        location.pathname.endsWith("/description") ||
        location.pathname.endsWith("/announcement") ||
        location.pathname.endsWith("/dpp") || 
        location.pathname.endsWith("/livetest") || 
        location.pathname.endsWith("/solution")
      )) || (
      location.pathname.startsWith("/book_details/") &&
      location.pathname.endsWith("/description")
    ) || (location.pathname.startsWith("/course_details/") &&

      (location.pathname.endsWith("/description") ||
        location.pathname.endsWith("/liveclass") ||
        location.pathname.endsWith("/lecture") ||
        location.pathname.endsWith("/livetests") ||
        location.pathname.endsWith("/dpp") || location.pathname.includes("/announcement") ||
        location.pathname.includes("/classroom/")
      )

    );

  return (
    <div className="App">
      {location.pathname !== UNPROTECTED_ROUTES?.login &&
        location.pathname !== UNPROTECTED_ROUTES?.studentDetails && (
          <NavbarComponent />
        )}
      <div className="grid grid-cols-[auto_1fr]">
        {location.pathname !== UNPROTECTED_ROUTES?.login &&
          location.pathname !== UNPROTECTED_ROUTES?.studentDetails &&
          (isSideBarOpen ? (
            <div className="w-[11rem]">
              <UnCollapsedSidebar />
            </div>
          ) : (
            <div className="grid grid-flow-col">
              <CollapsedSIdebar />
            </div>
          ))}
        <Outlet />
      </div>

      <Toaster />
      {!location.pathname.includes(UNPROTECTED_ROUTES?.courseDetails) &&
        !location.pathname.includes(UNPROTECTED_ROUTES?.testDetails) &&
        !location.pathname.includes(UNPROTECTED_ROUTES?.bookDetails) &&
        !location.pathname.includes(UNPROTECTED_ROUTES?.login) &&
        !location.pathname.includes(UNPROTECTED_ROUTES?.studentDetails) &&
        !location.pathname.includes(PROTECTED_ROUTES?.classroom) &&
        !location.pathname.includes(PROTECTED_ROUTES?.live) &&
        !location.pathname.includes(PROTECTED_ROUTES?.buy) &&
        !location.pathname.includes(PROTECTED_ROUTES?.payment) &&
        !location.pathname.includes(
          UNPROTECTED_ROUTES?.freeLibraryVideosPlay
        ) && <WhatsappFLoating />}
      {showScrollToTop && <ScrollToTopFloating />}

      {/* {location.pathname !== UNPROTECTED_ROUTES?.login &&
        location.pathname !== UNPROTECTED_ROUTES?.studentDetails && <Footer />} */}
      {/* {!hideFooterPaths.includes(location.pathname) && <Footer />} */}
      {!isHideFooterPath && <Footer />}
    </div>
  );
}

export default App;
